import Image, { ImageProps } from 'next/image'
import { useState } from 'react'

interface IUserImageProps extends Omit<ImageProps, 'src' | 'alt'> {
  src?: string | null
  alt?: string
  className?: string
  iconClassName?: string
}

import clsx from 'clsx'

import { IconUser } from 'icons'
const UserImage = ({
  src,
  className,
  iconClassName,
  alt = 'User image',
  ...options
}: IUserImageProps) => {
  const [hasError, setHasError] = useState(false)

  return (
    <div
      className={clsx(
        'relative flex h-8 w-8 items-center justify-center overflow-hidden rounded-full bg-gray-300 p-2 text-gray-500 ',
        className
      )}
    >
      {src && !hasError ? (
        <Image
          src={src}
          fill
          alt={alt}
          onError={() => setHasError(true)}
          {...options}
        />
      ) : (
        <IconUser className={clsx('h-[90%] w-[90%]', iconClassName)} />
      )}
    </div>
  )
}
export default UserImage
